import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Wrapper = styled.div`
    width: 100%;
`;

export const PageContainer = styled.div`
    width: 100%;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 20px;

    ${MediaQuery.xLarge(css`
        padding-left: 0;
        padding-right: 0;
        row-gap: 20px;
    `)};
`;

export const Header = styled.header`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;

    ${MediaQuery.medium(css`
        row-gap: 34px;
    `)};

    ${MediaQuery.xLarge(css`
        grid-auto-flow: column;
        grid-auto-columns: 1fr;
        row-gap: unset;
    `)};
`;

export const PageTitleContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 8px;
`;

export const ShipmentHeading = styled.h1`
    font-weight: 500;
    font-size: 28px;
    line-height: 130%;
    margin: 0;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 36px;
    `)};
`;

export const ShipmentCreatedAt = styled.p`
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    margin: 0;
    color: ${colors.BLACK};

    ${MediaQuery.medium(css`
        font-size: 16px;
    `)};
`;

export const StatusContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    div {
        margin-right: 0;
    }
    div:last-child {
        margin-right: 0;
        margin-top: 8px;
    }

    ${MediaQuery.medium(css`
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;

        div {
            margin-right: 20px;
        }

        div:last-child {
            margin-right: 0;
            margin-top: 0;
        }
    `)};

    ${MediaQuery.large(css`
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;

        div {
            margin-right: 20px;
        }

        div:last-child {
            margin-right: 0;
            margin-top: 0;
        }
    `)};
`;

export const ProgressContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 8px;
    grid-column: 1 / -1;

    ${MediaQuery.medium(css`
        grid-column: unset;
    `)};
`;

export const ProgressBar = styled.div`
    width: 148px;
    height: 3px;
    background-color: #D9D9D6;
    border-radius: 999px;
`;

export const ProgressBarTrack = styled.div`
    width: ${({ progress }) => progress || 0}%;
    border-radius: 999px;
    height: 100%;
    background-color: ${(props) => ((props.color) ? props.color : colors.BRAND_ORANGE)};
`;

export const ProgressStatus = styled.p`
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    color: ${colors.BLACK};
    margin: 0;
`;

export const DeliveryStatus = styled.div`
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${colors.BLACK};
    margin: 0;
    
    strong {
        font-weight: 600;
        display: block;
    }

    ${MediaQuery.medium(css`
        justify-self: center;
        font-size: 18px;
        
        strong {
            display: inline;
        }
    `)};
`;

export const ShipmentOptionsContainer = styled.div`
    grid-row: 2;
    grid-column: 2;
    justify-self: end;
    align-self: end;
    position: relative;

    ${MediaQuery.medium(css`
        grid-row: 1;
        grid-column: 3;
    `)};
`;

export const ShipmentOptionsButtonLabel = styled.div`
    display: grid;
    grid-template-columns: max-content max-content;
    column-gap: 8px;
    align-items: center;
`;

export const Body = styled.main`
    padding-top: 32px;
    border-top: 1px solid #D9D9D6;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 40px;
`;

export const Content = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    border-top: 1px solid #D9D9D6;
    padding: 32px 0;
    row-gap: 40px;

    ${MediaQuery.medium(css`
      row-gap: 48px;
    `)};
`;

export const SummaryContainer = styled.section`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 24px;
`;

export const SummaryTitle = styled.h2`
    font-weight: 500;
    font-size: 20px;
    line-height: 150%;
    color: ${colors.BLACK};
    margin: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 24px;

    ${MediaQuery.medium(css`
        font-size: 24px;
        flex-direction: row;
        gap: unset;
    `)};

    grid-column: 1 / -1;
`;

export const Table = styled.div`
    height: max-content;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 16px;
    padding: 24px;
    background-color: #F9F9F9;

    ${MediaQuery.medium(css`
        padding: 32px;
    `)};
`;

export const TableTitle = styled.h3`
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: ${colors.BLACK};
    grid-column: 1 / -1;
`;

export const TableCell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    ${MediaQuery.medium(css`
        flex-direction: row;
        justify-content: space-between;
    `)};
`;

export const InlineTableCell = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const MultilineTableCell = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const CellLabel = styled.p`
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
`;

export const CellValue = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
`;

export const CellValueLink = styled.a`
    text-decoration: none !important;
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: #007bff !important;
    cursor: pointer !important;
    &:hover {
        text-decoration: underline !important;
    }
`;

export const TableDivider = styled.div`
    height: 1px;
    width: 100%;
    background-color: #D9D9D6;
    grid-column: 1 / -1;

    &:last-child {
        display: none;
    }
`;

export const Addresses = styled.div`
  display: grid;
  grid-template-columns: max-content max-content;
  grid-template-rows: max-content max-content;
  row-gap: 4px;
  column-gap: 64px;
`;

export const AddressLabel = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${colors.BLACK};
  grid-row: 1;
`;

export const AddressValue = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.BLACK};
  grid-row: 2;

  ${MediaQuery.medium(css`
    font-size: 18px;
  `)};
`;
